/* PawlyBuddy Product Gallery */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pb-gallery-main').forEach(function (main) {
    const container = main.closest('.pb-product-gallery, .pb-feat-gallery');
    if (!container) return;
    const thumbs = container.querySelectorAll('.pb-thumb');
    const mainImg = main.querySelector('img');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src || (thumb.querySelector('img') ? thumb.querySelector('img').src : null);
        if (mainImg && src) { mainImg.style.opacity = '0'; setTimeout(function(){ mainImg.src = src; mainImg.style.opacity = '1'; }, 180); }
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('active');
  });
});